import type { Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';

const maxWidth = '718px';

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    maxWidth: maxWidth,
    [theme.breakpoints.down('md')]: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      boxShadow: 'none',
    },
  },
  item: {
    padding: `${theme.spacing(2)} 0`,
    minHeight: theme.spacing(3),
  },
  mapItem: {
    minHeight: theme.spacing(30),
  },
  textField: {
    height: theme.spacing(5),
    margin: theme.spacing(0.5),
    padding: `0 ${theme.spacing(2)} 0 0`,
    [theme.breakpoints.down('md')]: {
      margin: 0,
    },
  },
  grey: {
    color: 'rgba(0, 0, 0, 0.6)',
  },
  alignSelfCenter: {
    alignSelf: 'center',
  },
  gridItem: {
    padding: `${theme.spacing(1.5)}!important`,
    [theme.breakpoints.down('md')]: { padding: theme.spacing(1) },
  },
  enterAddressManually: {
    cursor: 'pointer',
  },
}));

export const TimezoneTypographyStyled = styled(Typography)({
  lineHeight: '40px',
  marginLeft: 0,
});

export const DisabledTimezoneTypographyStyled = styled(Typography)({
  lineHeight: '40px',
  marginLeft: 0,
  color: 'rgba(0,0,0,0.38)',
});
